// This file is imported in project_profile_report.service.js also!

export const reasonsForResubmissionTitleAndOptions = [{
  title: 'changes_to_the_applicant_company',
  options: ['changes_of_applicant_company', 'change_in_the_legal_form_of_applicant_company']
}, {
  title: 'changes_to_the_scope_of_the_project',
  options: ['changes_in_term', 'changes_in_form_of_activity', 'changes_in_personnel_framework', 'changes_in_financial_framework']
}, {
  title: 'changes_to_the_content_of_the_project',
  options: ['changes_in_rd_approach', 'changes_additions_to_work_packages']
}, {
  title: 'changes_to_contractors',
  options: ['changes_of_contractor', 'additional_contractor', 'change_in_the_subject_matter_of_the_order__work']
}, {
  title: 'changes_to_assets',
  options: ['additional_asset', 'changes_of_assets']
}, {
  title: 'other_changes',
  options: ['initial_other_changes', 'other_changes']
}];